// @flow
export const ROUTE = 'marketplace/ROUTE';
export const route = () => ({
  type: ROUTE,
});
